// 詳情頁的「版本」段落（GDO-30）：標準版與合併進來的其他版本，各自的發售日、提前天數與購買連結。
import { parseReleaseDate, releaseSortKey } from '@dayone/core/release-date';
import type { GameDetail } from '@dayone/core/snapshot';
import { t } from '../../i18n/zh-TW.ts';
import { formatRelease } from '../../lib/format.ts';
import { Hint } from '../../ui/Hint.tsx';
import { ExternalLink, ICON } from '../../ui/icons/index.ts';
import { editionLabel } from '../catalog/editions.tsx';

export function EditionsSection({ detail, currentYear }: { detail: GameDetail; currentYear: number }) {
  if (!detail.editions?.length) return null;
  const main = parseReleaseDate(detail.date);
  const fmt = (d: string) => {
    const r = parseReleaseDate(d);
    return r ? formatRelease(r, currentYear) : d;
  };
  const earlier = (d: string) => {
    const r = parseReleaseDate(d);
    if (r?.p !== 'day' || main?.p !== 'day') return 0;
    return releaseSortKey(main) - releaseSortKey(r);
  };
  return (
    <section className="detail-section dt-editions">
      <h3>
        <Hint text={t.editions.section} content={t.editions.sectionHint} />
      </h3>
      <ul className="edition-list">
        <li>
          <span className="edition-name">{t.editions.standard}</span>
          <span className="edition-date num">{fmt(detail.date)}</span>
        </li>
        {detail.editions.map((e) => {
          const label = editionLabel(e.title);
          const days = earlier(e.date);
          return (
            <li key={e.id}>
              <span className="edition-name">
                {label}
                {label !== e.title && <small lang="en">{e.title}</small>}
              </span>
              <span className="edition-date num">
                {fmt(e.date)}
                {days > 0 && <span className="badge badge-accent">{t.editions.earlyDays(days)}</span>}
              </span>
              {e.links.length > 0 && (
                <span className="edition-links">
                  {e.links.map((l) => (
                    <a
                      key={l.url}
                      className="edition-link"
                      href={l.url}
                      target="_blank"
                      rel="noopener noreferrer"
                      aria-label={`${t.editions.buy(label)}：${t.linkKinds[l.kind] ?? l.kind}`}
                    >
                      {t.linkKinds[l.kind] ?? l.kind}
                      <ExternalLink {...ICON} />
                    </a>
                  ))}
                </span>
              )}
            </li>
          );
        })}
      </ul>
    </section>
  );
}
